import { Link, useParams } from 'react-router-dom'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FormInput, VerticalForm } from '../../components/Form'
import { reqResetPassword } from '../../store/user/userThunk'
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import logo from "../../assets/images/logo.svg"
// Form validation schema
const schemaResolver = yupResolver(
    yup.object().shape({
        email: yup.string().required('Please enter email').email('Please enter a valid email'),
    })
)

const RecoverPassword = () => {
    const dispatch = useDispatch()
    const params = useParams()

    useEffect(() => {
        if (document.body) {
            document.body.classList.add('bg-gradient-to-br', 'from-blue-50', 'to-blue-100', 'tracking-wide')
        }
        return () => {
            if (document.body) {
                document.body.classList.remove('bg-gradient-to-br', 'from-blue-50', 'to-blue-100', 'tracking-wide')
            }
        }
    }, [])
    
        const methods = useForm({ resolver: schemaResolver });
    const {
        reset,
        formState: { errors },
    } = methods;
    const onSubmit = async (data) => {
        try {
            await dispatch(reqResetPassword(data)).unwrap()
            toast.success('Password reset link sent successfully!')
            reset()
        } catch (error) {
            console.log(error ,"error.messageerror.messageerror.message")
            toast.error(error || 'Failed to send reset link. Please try again.')
            reset()
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="container mx-auto">
                <div className="flex justify-center">
                    <div className="lg:w-1/2 w-full max-w-md">
                        <div className="bg-white shadow-2xl rounded-2xl p-8 transform transition-all  duration-300">
                            <div className="mb-8 text-center">
                                {/* <Link to="/">
                                    <img src={logo} alt="logo-img" className="h-12 mx-auto" />
                                </Link> */}
                                <h6 className="text-2xl font-bold text-gray-800 mt-6">
                                    Reset Your Password
                                </h6>
                                <p className="text-gray-600 text-sm mt-2 mb-6">
                                    Enter your email address and we'll send you instructions to reset your password.
                                </p>
                            </div>
                            <VerticalForm
                                onSubmit={onSubmit}
                                resolver={schemaResolver}
                            >
                                <FormInput
                                    name="email"
                                    label="Email Address"
                                    containerClass="mb-6"
                                    labelClassName="block text-sm font-medium mb-2 text-gray-700"
                                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-[#50B5FF] focus:ring-2 focus:ring-[#50B5FF]/30 transition duration-200"
                                    placeholder="Enter your email"
                                />
                                <div className="pt-4 text-center">
                                    <button
                                        className="w-full bg-[#50B5FF] text-white font-semibold py-3 px-4 rounded-lg transition-all hover:bg-[#3a9fee] hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#50B5FF]/50 focus:ring-opacity-50"
                                        type="submit"
                                    >
                                        Send Reset Link
                                    </button>
                                </div>
                            </VerticalForm>
                            <div className="mt-6 text-center">
                                <p className="text-gray-600 text-sm">
                                    Remember your password?{' '}
                                    <Link
                                        to="/auth/sign-in"
                                        className="text-[#50B5FF] font-semibold hover:underline"
                                    >
                                        Log In
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default RecoverPassword